<template>
  <div class="receipt-form-container">
    <!-- 页面头部 + 面包屑 -->
    <div class="page-header">
      <div class="header-left">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/Welcome' }">
            <i class="el-icon-s-home"></i> 首页
          </el-breadcrumb-item>
          <el-breadcrumb-item>财务管理</el-breadcrumb-item>
          <el-breadcrumb-item>{{ id ? '编辑收款单' : '新增收款单' }}</el-breadcrumb-item>
        </el-breadcrumb>
        
      </div>
      <div class="header-right">
        <el-button icon="el-icon-back" size="small" @click="goBack">返回</el-button>
      </div>
    </div>

    <!-- 表单卡片 -->
    <el-card class="form-card" shadow="never">
      <el-form
        :inline="false"
        :model="addForm"
        :rules="rules"
        ref="formForRef"
        label-width="100px"
        label-position="right"
        size="small"
        class="alipay-form"
      >
        <!-- 按钮栏 -->
        <div class="form-actions">
          <el-button icon="el-icon-check" type="primary" size="small" @click="submitForm('addForm')" :loading="submitLoading">保存</el-button>
          <el-button type="warning" size="small" icon="el-icon-download" :disabled="!addForm.id" @click="showDoc">附件</el-button>
          <el-button icon="el-icon-close" size="small" @click="resetForm('addForm')">重置</el-button>
        </div>

        <el-row :gutter="24">
          <el-col :xs="24" :sm="12" :md="8" :lg="8">
            <el-form-item label="付款单位" prop="pay_name">
              <el-input placeholder="请输入付款单位" v-model="addForm.pay_name"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="8">
            <el-form-item label="付款日期" prop="pay_time">
              <el-date-picker
                clearable
                type="date"
                placeholder="选择付款日期"
                v-model="addForm.pay_time"
                style="width: 100%;"
                value-format="timestamp"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="8">
            <el-form-item label="费用类别" prop="cate_id">
              <el-select v-model="addForm.cate_id" placeholder="请选择费用类别" clearable>
                <el-option
                  v-for="item in cateMenus"
                  :key="item.id"
                  :label="item.pid > 0 ? '|--' + item.name : item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :xs="24" :sm="12" :md="8" :lg="8">
            <el-form-item label="凭证号">
              <el-input placeholder="请输入凭证号" v-model="addForm.num"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="8">
            <el-form-item label="金额">
              <el-input placeholder="请输入金额" v-model="addForm.amount" type="number">
                <template slot="prepend">¥</template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="8">
            <el-form-item label="缴款方式">
              <el-select v-model="addForm.fee_way_id" placeholder="请选择缴款方式" clearable>
                <el-option
                  v-for="item in feeWayList"
                  :key="item.id"
                  :label="item.pid > 0 ? '|--' + item.name : item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :xs="24" :sm="12" :md="8" :lg="8">
            <el-form-item label="所属合同">
              <el-input
                placeholder="请选择所属合同"
                readonly
                v-model="formData.name"
                @click.native="chooseContract"
                class="picker-input"
              >
                <i slot="suffix" class="el-icon-more el-input__icon"></i>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="8">
            <el-form-item label="所属项目">
              <el-select v-model="addForm.project_id" placeholder="请选择所属项目" clearable>
                <el-option
                  v-for="item in formData.projectList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :xs="24" :sm="12" :md="8" :lg="8">
            <el-form-item label="收款部门">
              <el-cascader
                v-model="addForm.department_id"
                :props="{ value: 'id', label: 'name', checkStrictly: true, emitPath: false }"
                :options="departmentList"
                :show-all-levels="false"
                placeholder="请选择收款部门"
                clearable
              ></el-cascader>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="8">
            <el-form-item label="收款人">
              <el-input
                placeholder="请选择收款人"
                readonly
                v-model="addForm.employee_name"
                @click.native="chooseEmployee"
                class="picker-input"
              >
                <i slot="suffix" class="el-icon-more el-input__icon"></i>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item label="备注">
              <el-input
                type="textarea"
                :rows="3"
                placeholder="请输入备注"
                v-model="addForm.remark"
                maxlength="255"
                show-word-limit
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- 富文本编辑器（保留原功能） -->
        <el-row :gutter="24" v-if="false">
          <el-col :span="24">
            <el-form-item label="内容">
              <div class="editor-wrapper">
                <Toolbar
                  :editor="editor"
                  :defaultConfig="toolbarConfig"
                  :mode="mode"
                />
                <Editor
                  v-model="addForm.content"
                  :defaultConfig="editorConfig"
                  :mode="mode"
                  @onCreated="onCreated"
                  @onChange="onChange"
                />
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>

    <!-- 子组件弹窗 -->
    <eContractList
      :formData="formData"
      :visible.sync="visible"
      :title="title"
      :closeForm="closeForm"
    />
    <eEmployeeList
      :formData="formData1"
      :visible.sync="visible1"
      :title="title1"
      :closeForm="closeForm1"
    />
    <eDocList
      :formData="formData4"
      :visible.sync="visible4"
      :title="title4"
      :closeForm="closeForm4"
    />
  </div>
</template>

<script>
import eContractList from "../common/eContractList.vue"
import eEmployeeList from "../common/eEmployeeList.vue"
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
import moment from 'moment'
import axios from 'axios'
import eDocList from "../common/eDocList"

export default {
  name: "receiptForm",
  components: { Editor, Toolbar, eContractList, eEmployeeList, eDocList },
  data() {
    return {
      submitLoading: false,
      id: null,
      formData: {},
      visible: false,
      title: '',
      formData1: {},
      visible1: false,
      title1: '',
      formData4: {},
      title4: '',
      visible4: false,
      feeWayList: [],
      departmentList: [],
      addForm: {
        num: '',
        fee_way_id: '',
        pay_time: '',
        pay_name: '',
        name: '',
        upload_time: '',
        department_id: '',
        employee_id: '',
        employee_name: '',
        cate_id: '',
        url: '',
        id: '',
        content: '',
        file_url: '',
        video_url: '',
        project_id: '',
        contract_id: '',
        amount: '',
        remark: ''
      },
      cateMenus: [],
      editor: null,
      toolbarConfig: { modalAppendToBody: true },
      editorConfig: {
        placeholder: '请输入内容...',
        MENU_CONF: {
          uploadImage: { customUpload: this.uploadImg }
        }
      },
      mode: 'default',
      rules: {
        pay_name: [{ required: true, message: "请输入付款单位", trigger: 'blur' }],
        pay_time: [{ required: true, message: "请选择付款日期", trigger: 'change' }],
        cate_id: [{ required: true, message: "请选择分类", trigger: 'change' }]
      }
    }
  },
  mounted() {
    this.getCateMenus()
    this.getFeeWayList()
    this.getDepartmentList()
    const uri = this.urlParse()
    this.id = uri.searchParams.id
    if (this.id) {
      this.getOne()
    }
  },
  beforeDestroy() {
    if (this.editor) this.editor.destroy()
  },
  methods: {
    showDoc() {
      this.title4 = "选择附件管理"
      this.visible4 = true
      this.formData4.source = 2
      this.formData4.foreign_id = this.addForm.id
    },
    closeForm() {
      this.formData = {}
      this.title = ""
      this.visible = false
    },
    chooseContract() {
      this.formData = {}
      this.visible = true
    },
    closeForm1() {
      this.addForm.employee_id = this.formData1.id
      this.addForm.employee_name = this.formData1.name
      this.title1 = ""
      this.visible1 = false
    },
    closeForm4() {
      this.formData4 = {}
      this.title4 = ""
      this.visible4 = false
    },
    chooseEmployee() {
      this.formData1 = {}
      this.title1 = "员工信息"
      this.visible1 = true
    },
    getDepartmentList() {
      const param = {
        company_id: sessionStorage.getItem('company_id'),
        access_token: sessionStorage.getItem('token')
      }
      this.$axios.shopDepartmentTree(param).then(res => {
        if (res.code === 200) this.departmentList = res.data
      }).catch(err => console.log(err))
    },
    getFeeWayList() {
      const param = {
        company_id: sessionStorage.getItem('company_id'),
        access_token: sessionStorage.getItem('token'),
        code: "FeeWay"
      }
      this.$axios.dicListByPid(param).then(res => {
        if (res.code === 200) this.feeWayList = res.data
      }).catch(err => console.log(err))
    },
    goBack() {
      this.$router.go(-1)
    },
    submitForm() {
      this.$refs.formForRef.validate(valid => {
        if (!valid) return
        this.submitLoading = true
        const param = {
          id: this.addForm.id,
          access_token: sessionStorage.getItem('token'),
          company_id: sessionStorage.getItem('company_id'),
          name: this.addForm.name,
          employee_id: this.addForm.employee_id,
          department_id: this.addForm.department_id,
          link: this.addForm.url,
          content: this.addForm.content,
          summary: this.addForm.summary,
          ishot: this.addForm.ishot ? 1 : 0,
          recommond: this.addForm.recommond ? 1 : 0,
          istop: this.addForm.istop ? 1 : 0,
          upload_time: this.addForm.upload_time,
          cate_id: this.addForm.cate_id,
          operator_id: this.formData1.id,
          contract_id: this.formData.id,
          project_id: this.addForm.project_id,
          amount: this.addForm.amount,
          pay_time: this.addForm.pay_time,
          pay_name: this.addForm.pay_name,
          remark: this.addForm.remark,
          fee_way_id: this.addForm.fee_way_id,
          num: this.addForm.num
        }
        this.$axios.receiptSave(param).then(res => {
          this.submitLoading = false
          if (res.code === 200) {
            this.$message.success('保存成功！')
            this.$router.push('/receiptList')
          } else {
            this.$message.error(res.msg || '保存失败')
          }
        }).catch(err => {
          console.log(err)
          this.submitLoading = false
          this.$message.error('网络异常')
        })
      })
    },
    getOne() {
      const param = {
        id: this.id,
        operator_id: sessionStorage.getItem('user_id'),
        company_id: sessionStorage.getItem('company_id'),
        access_token: sessionStorage.getItem('token')
      }
      this.$axios.findReceiptOne(param).then(res => {
        if (res.code === 200) {
          const item = res.data
          this.addForm.pay_name = item.pay_name
          this.addForm.cate_id = item.cate_id
          this.addForm.amount = item.amount
          this.addForm.fee_way_id = item.fee_way_id
          this.addForm.num = item.num
          this.addForm.remark = item.remark
          this.addForm.department_id = item.department_id
          this.addForm.pay_time = item.pay_time > 0 ? this.dateFormat(item.pay_time * 1000) : ''
          this.addForm.url = item.link
          // 可根据需要赋值合同、项目等
        }
      }).catch(err => console.log(err))
    },
    dateFormat(time, arg = 'YYYY-MM-DD HH:mm:ss') {
      return moment(time).format(arg)
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
    getCateMenus() {
      const param = {
        operator_id: sessionStorage.getItem('user_id'),
        company_id: sessionStorage.getItem('company_id'),
        access_token: sessionStorage.getItem('token')
      }
      this.$axios.findFeeCategoryTable(param).then(res => {
        if (res.code === 200) this.cateMenus = res.data
      }).catch(err => console.log(err))
    },
    uploadImg(file, insertFn) {
      // 图片上传逻辑（保持原样）
      const param = {
        access_token: sessionStorage.getItem('token'),
        company_id: sessionStorage.getItem('company_id')
      }
      this.$axios.getAliJson(param).then(res => {
        const data = res.data
        const suffix = this.get_suffix(file.name)
        const autoname = this.Ymdhis()
        const key = data.dir
        const host = data.host
        const request = new FormData()
        request.append('name', file.name)
        request.append("key", key + 'mrh/' + autoname + suffix)
        request.append("policy", data.policy)
        request.append("OSSAccessKeyId", data.accessid)
        request.append("success_action_status", '200')
        request.append("callback", data.callback)
        request.append("Signature", data.signature)
        request.append('file', file)
        axios.post('/alioss', request, { headers: { 'Content-Type': 'multipart/form-data' } }).then(resp => {
          const fileurl = resp.data.filename
          const fullurl = host + '/' + fileurl
          setTimeout(() => insertFn(fullurl), 500)
        }).catch(err => console.log(err))
      })
    },
    get_suffix(filename) {
      const pos = filename.lastIndexOf('.')
      return pos !== -1 ? filename.substring(pos) : ''
    },
    Ymdhis() {
      const date = new Date()
      return '' + date.getFullYear() + (date.getMonth() + 1) + date.getDate() + date.getHours() + date.getMinutes() + date.getSeconds()
    },
    urlParse(_url = '') {
      const url_obj = new URL(_url || window.location.href)
      const search_path = url_obj.search
      const handle_path = decodeURIComponent(search_path.substr(1))
      const handle_path_arr = handle_path.split('&')
      const search_params = {}
      for (let item of handle_path_arr) {
        const r = item.split('=')
        search_params[r[0]] = r[1]
      }
      return {
        protpcol: url_obj.protocol,
        search: url_obj.search,
        host: url_obj.host,
        port: url_obj.port,
        pathname: url_obj.pathname,
        searchParams: search_params
      }
    },
    onChange() {},
    onCreated(editor) {
      this.editor = Object.seal(editor)
    }
  }
}
</script>

<style lang="scss" scoped>
// 支付宝风格变量
$primary-color: #1677ff;
$success-color: #00b42a;
$danger-color: #f53f3f;
$warning-color: #ff7d00;
$text-primary: #1f2d3d;
$text-regular: #4e5969;
$text-secondary: #86909c;
$border-color: #e5e6eb;
$bg-gray: #f7f8fa;
$card-shadow: 0 2px 8px rgba(0, 0, 0, 0.04), 0 1px 2px rgba(0, 0, 0, 0.02);

.receipt-form-container {
  padding: 20px 24px;
  background: $bg-gray;
  min-height: calc(100vh - 84px);
}

/* 页面头部 */
.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  .header-left {
    .el-breadcrumb {
      margin-bottom: 12px;
      ::v-deep .el-breadcrumb__item {
        .el-breadcrumb__inner {
          color: $text-secondary;
          font-size: 13px;
          &.is-link {
            color: $primary-color;
            &:hover { color: lighten($primary-color, 10%); }
          }
        }
        &:last-child .el-breadcrumb__inner {
          color: $text-primary;
          font-weight: 500;
        }
      }
    }
    .title-wrapper {
      display: flex;
      align-items: baseline;
      gap: 12px;
    }
    .page-title {
      margin: 0;
      font-size: 24px;
      font-weight: 600;
      color: $text-primary;
      letter-spacing: -0.3px;
    }
  }
  .header-right {
    .el-button {
      border-radius: 20px;
    }
  }
}

/* 表单卡片 */
.form-card {
  border-radius: 16px;
  border: none;
  box-shadow: $card-shadow;
  ::v-deep .el-card__body {
    padding: 24px;
  }
}

/* 表单样式 */
.alipay-form {
  .form-actions {
    margin-bottom: 24px;
    padding-bottom: 16px;
    border-bottom: 1px solid $border-color;
    .el-button {
      border-radius: 20px;
      padding: 7px 20px;
      font-weight: 500;
      & + .el-button {
        margin-left: 12px;
      }
    }
  }
  ::v-deep .el-form-item {
    margin-bottom: 20px;
    .el-form-item__label {
      font-weight: 500;
      color: $text-regular;
      font-size: 13px;
    }
    .el-input__inner,
    .el-textarea__inner,
    .el-select .el-input__inner,
    .el-cascader__input {
      border-radius: 8px;
      border-color: $border-color;
      transition: all 0.2s;
      &:focus {
        border-color: $primary-color;
        box-shadow: 0 0 0 2px rgba($primary-color, 0.1);
      }
    }
    .el-input-group__prepend {
      border-radius: 8px 0 0 8px;
      background: $bg-gray;
      border-color: $border-color;
    }
    .picker-input {
      cursor: pointer;
      .el-input__suffix {
        cursor: pointer;
        color: $primary-color;
      }
    }
  }
  ::v-deep .el-cascader {
    width: 100%;
  }
  ::v-deep .el-date-editor.el-input {
    width: 100%;
  }
  .editor-wrapper {
    border: 1px solid $border-color;
    border-radius: 12px;
    overflow: hidden;
    transition: all 0.2s;
    &:focus-within {
      border-color: $primary-color;
      box-shadow: 0 0 0 2px rgba($primary-color, 0.1);
    }
  }
}

/* 响应式 */
@media (max-width: 768px) {
  .receipt-form-container {
    padding: 16px;
  }
  .alipay-form .form-actions {
    .el-button {
      width: 100%;
      margin: 0 0 8px 0 !important;
    }
  }
}
</style>